import {Injectable} from '@angular/core';
import {SortDataColumn} from "../models/table.model";
import {BehaviorSubject, Subject} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class SortTableService {

  sortColum$: Subject<string | undefined> = new BehaviorSubject<string | undefined>(undefined)

  sortColumnData: SortDataColumn | undefined

  sort(column: string): SortDataColumn | undefined {
    if (this.sortColumnData?.field === column) {
      if (this.sortColumnData.order === 'ASC') {
        this.sortColumnData.order = 'DESC'
        return this.sortColumnData
      } else {
        this.sortColumnData.order = 'ASC'
        return this.sortColumnData
      }
    } else {
      this.sortColumnData = {
        field: column,
        order: 'ASC'
      }
      return this.sortColumnData
    }
  }

}
